import {
  BaseModal,
  Button,
  Dropdown,
  DropdownItem,
  DropdownList,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import React, { FC, useEffect, useState } from 'react';
import { ReactComponent as CsRepIcon } from '../../../assets/icons/reassgin_csrep.svg';
import { ArrowDownIcon } from 'cokitchen-icons';
import { toast } from 'react-toastify';
import { apiService } from 'utils/api';
import { OrderType } from 'models/order.model';
import { getUserName } from 'utils/functions';

type Props = {
  show: boolean;
  onClose: () => void;
  order: OrderType;
};

type ReAssignRepooterProps = {
  loading: boolean;
  onConfirm: () => void;
};
type CsRepType = {
  name: string;
  id: string;
};

const ReAssignRepFooter: FC<ReAssignRepooterProps> = ({ onConfirm, loading }) => (
  <div>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);
const ReAssignRepModal: FC<Props> = ({ show, onClose, order }) => {
  const [loading, setLoading] = useState(false);
  const [csRepList, setCsRepList] = useState<CsRepType[]>([]);
  const [csRepLoading, setCsRepLoading] = useState(false);
  const [selectedCsRep, setSelectedCsRep] = useState<CsRepType>();
  const [showDropdown, setShowDropdown] = useState(false);
  useEffect(() => {
    getAllReps();
  }, []);
  const getAllReps = async () => {
    setCsRepLoading(true);
    try {
      const res = await apiService.get('cs/staff/all/list', {
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      const csList = res.data?.data
        ?.filter((item: any) => item.role === 'CUSTOMER_SERVICE_OUTBOUND')
        ?.map((item: any) => {
          return {
            name: getUserName(item),
            id: item.id
          };
        });
      setCsRepList(csList);
      const selectedRep = csList.find((item: CsRepType) => item.id === order?.assigned_rep_id);
      setSelectedCsRep(selectedRep);
    } finally {
      setCsRepLoading(false);
    }
  };
  const reAssignRep = () => {
    setLoading(true);
    const data = {
      order_id: order.id,
      user_id: selectedCsRep?.id
    };
    try {
      apiService.post('cs/staff/orders/reassign', {
        data,
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message='Reassign successful' />);
      onClose();
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      onRequestClose={() => onClose()}
      title={`Reassign rep for Order #${order.order_code}`}
      titleIcon={<CsRepIcon />}
      titleIconColor='info'
      description='Change C.S rep assigned to this order'
      footer={<ReAssignRepFooter loading={loading} onConfirm={reAssignRep} />}>
      <p className='mb-2 font-medium'>CS Rep</p>
      <Dropdown
        placement='bottom-start'
        visible={showDropdown}
        onClickOutside={() => setShowDropdown(false)}
        content={
          <div
            className='px-5 py-3 flex items-center cursor-pointer justify-between text-sm gap-3 font-medium w-full border-[1px] border-[#E0DADB] rounded-lg'
            onClick={() => setShowDropdown(!showDropdown)}>
            <span>{selectedCsRep ? selectedCsRep.name : 'Select CS Rep'}</span>
            <ArrowDownIcon />
          </div>
        }>
        <DropdownList>
          {csRepLoading ? (
            <DropdownItem className='text-center'>Loading...</DropdownItem>
          ) : (
            csRepList.map((item, index) => (
              <DropdownItem
                key={index}
                onClick={() => {
                  setSelectedCsRep(item);
                  setShowDropdown(false);
                }}>
                {item.name}
              </DropdownItem>
            ))
          )}
        </DropdownList>
      </Dropdown>
    </BaseModal>
  );
};

export default ReAssignRepModal;
